<template>
  <div class="flex justify-between py-2">
    <span class="font-medium">
      {{ $t(label) }}
    </span>
    <button
      class="flex items-center gap-2 border-primary-700 bg-primary pe-2 rounded hover:opacity-80"
      @click.prevent="onDownloadClick"
    >
      <div class="size-6 bg-primary-700 flex justify-center items-center rounded-s">
        <faFileLines class="w-2.5 fill-white" />
      </div>
      <span class="leading-none text-white text-xs ltr:font-sans">
        {{ $t(button_label) }}
      </span>
    </button>
  </div>
</template>

<script setup>
import { useAttrs } from 'vue'
import faFileLines from '@/assets/icons/faFileLines.svg'
import { useGlobalStore } from '@/stores/global'

const globalStore = useGlobalStore()

const { label, button_label, document_label, href } = useAttrs()

async function onDownloadClick() {
  const link = document.createElement('a')

  link.href = globalStore.languageId == 2 ? href.en : href.ar
  link.target = '_blank'
  link.download = ''
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>

<style lang="scss" scoped></style>
